import { IProjectApplicant } from '../../../../interfaces/projectApplicant';
import { ITableColumn } from '../../../../interfaces/tableProps';
import { IPaymentRate } from '../../../../interfaces/paymentRate';
import { theme } from '../../../../theme';
import { useMemo } from 'react';
import { FREELANCERS_PATH } from '../../../../router/paths';
import AppTable from '../../AppTable';
import { PAYMENT_RATE_MAP } from '../../../../enums/paymentRateType';
import { PROJECT_APPLICANT_STATUS_MAP, ProjectApplicantStatus } from '../../../../enums/projectApplicantStatus';

const columns: ITableColumn<keyof IProjectApplicant>[] = [
  {
    name: 'freelancerId',
    label: 'Freelancer ID',
    sx: { '&:hover': { cursor: 'pointer', textDecoration: 'underline', color: theme.palette.primary.dark } },
    withCopyIcon: true,
  },
  { name: 'freelancerName', label: 'Freelancer Name', truncate: 50 },
  { name: 'freelancerRoleName', label: 'Freelancer Role', truncate: 50 },
  { name: 'freelancerMessage', label: 'Freelancer Message', truncate: 20 },
  {
    name: 'rate',
    label: 'Rate',
    format: (rate: IPaymentRate) => `${rate.amount} ${rate.currency} / ${PAYMENT_RATE_MAP[rate.type]}`
  },
  { name: 'status', label: 'Status', format: (val: ProjectApplicantStatus) => PROJECT_APPLICANT_STATUS_MAP[val] },
];

interface IProps {
  applicants: IProjectApplicant[];
}

const ApplicantsTable = ({ applicants }: IProps) => {
  const handlers: { [key: string]: (val: IProjectApplicant) => void } = useMemo(() => ({
    freelancerId: (a) => window.open(FREELANCERS_PATH + `/${a.freelancerId}`, '_blank', 'noopener,noreferrer')
  }), []);

  return (
    <AppTable
      data={{ list: applicants }} handlers={handlers}
      columns={columns}
    />
  );
};

export default ApplicantsTable;